import React from 'react';

interface SnowmanIconProps {
	/** Icon size in pixels. Defaults to 32. */
	size?: number;
}

export const SnowmanIcon: React.FC<SnowmanIconProps> = ({ size = 32 }) => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 48 48"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		aria-label="Snowman assistant icon"
	>
		<defs>
			<linearGradient id="cb-body" x1="0" y1="0" x2="0" y2="1">
				<stop offset="0%" stopColor="#FFFFFF" />
				<stop offset="100%" stopColor="#DCEBFF" />
			</linearGradient>
			<linearGradient id="cb-scarf" x1="0" y1="0" x2="1" y2="0">
				<stop offset="0%" stopColor="#EF4444" />
				<stop offset="100%" stopColor="#B91C1C" />
			</linearGradient>
		</defs>

		<g transform="translate(24 24)">
			{/* Body - bottom snowball */}
			<circle cx="0" cy="9" r="10" fill="url(#cb-body)" stroke="#B6D4F2" strokeWidth="1.2" />
			{/* Head */}
			<circle cx="0" cy="-4" r="8" fill="url(#cb-body)" stroke="#B6D4F2" strokeWidth="1.2" />

			{/* Headphone band */}
			<path d="M -9 -5 C -9 -14 9 -14 9 -5" stroke="#444" strokeWidth="1.8" fill="none" strokeLinecap="round" />
			{/* Left ear cup */}
			<rect x="-12" y="-8" width="4.5" height="7" rx="2" fill="#555" stroke="#333" strokeWidth="0.7" />
			{/* Right ear cup */}
			<rect x="7.5" y="-8" width="4.5" height="7" rx="2" fill="#555" stroke="#333" strokeWidth="0.7" />
			{/* Mic arm */}
			<path d="M -10 -1 C -13 2 -12 6 -9 7" stroke="#555" strokeWidth="1.3" fill="none" strokeLinecap="round" />
			{/* Mic dot */}
			<circle cx="-9" cy="7" r="1.8" fill="#EF4444" stroke="#B91C1C" strokeWidth="0.5" />

			{/* Eyes */}
			<circle cx="-2.5" cy="-6" r="1.2" fill="#1F2937" />
			<circle cx="2.5" cy="-6" r="1.2" fill="#1F2937" />

			{/* Carrot nose */}
			<polygon points="0,-3.5 5,-2 0,-0.5" fill="#F59E0B" />

			{/* Smile */}
			<path d="M -2 1 Q 0 2.5 2 1" stroke="#1F2937" strokeWidth="0.9" fill="none" strokeLinecap="round" />

			{/* Buttons */}
			<circle cx="0" cy="6" r="1" fill="#334155" />
			<circle cx="0" cy="10" r="1" fill="#334155" />

			{/* Scarf */}
			<rect x="-8" y="2" width="16" height="2.8" rx="1" fill="url(#cb-scarf)" />
			{/* Scarf tail */}
			<path d="M 3.5 4.8 C 5 7 5 10 3.5 12.5 H 6 C 7.5 10 7.5 7 6 4.8 Z" fill="url(#cb-scarf)" />
		</g>
	</svg>
);
